import ClayTable from "@clayui/table";
import ClayButton, {ClayButtonWithIcon} from "@clayui/button";
import DateTimeRenderer from "../renderers/DateTimeRenderer";
import React, {useState} from "react";
import {selectCart, updateCart} from "../util/Api";
import ClayLoadingIndicator from "@clayui/loading-indicator";
import {useTranslation} from "react-i18next";

const OrderTableRow = ({order, deleteAction, setCurrentCart, setExpand}) => {
    const { t } = useTranslation();
    const [name, setName] = useState(order.customFields.cartCustomName)
    const [nameEdit, setNameEdit] = useState(false);
    const [nameEditInProgress, setNameEditInProgress] = useState(false);
    const onNameEditSubmit = () => {
        setNameEditInProgress(true);
        order.customFields.cartCustomName = name;
        updateCart(order)
            .then(response => {
                if (response.status !== 200) {
                    alert(t("an-unexpected-error-occurred"));
                }
            })
            .finally(() => {
                setNameEdit(false);
                setNameEditInProgress(false);
            });
    }

    const selectOrder = () => {
        selectCart(order.id)
            .then(response => {
                setCurrentCart(order);
                setExpand(false);
                Liferay.fire("current-order-updated");
                window.refreshMiniCarts();
            }).catch(e => alert(t("an-unexpected-error-occurred")));
    }

    return (
        <ClayTable.Row>
            <ClayTable.Cell headingTitle>
                <ClayButton displayType="none" onClick={selectOrder}>
                    {order.id}
                </ClayButton>
            </ClayTable.Cell>

            <ClayTable.Cell className="name-column">
                {nameEdit ?
                    (
                        <div>
                            {nameEditInProgress ?
                                <ClayLoadingIndicator size="xs"/>
                                :
                                <div className="d-flex align-items-center">
                                    <input disabled={!nameEdit} className="w-100" value={name}
                                           onChange={e => setName(e.target.value)}/>
                                    <ClayButtonWithIcon onClick={onNameEditSubmit}
                                                        symbol="check" displayType="none"
                                                        spritemap={Liferay.ThemeDisplay.getPathThemeImages() + "/clay/icons.svg"}/>
                                </div>
                            }
                        </div>
                    ) :
                    (
                        <div className="d-flex align-items-center">
                            {name}
                            <ClayButtonWithIcon onClick={() => setNameEdit(true)}
                                                symbol="pencil" displayType="none"
                                                spritemap={Liferay.ThemeDisplay.getPathThemeImages() + "/clay/icons.svg"}/>
                        </div>
                    )
                }
            </ClayTable.Cell>

            <ClayTable.Cell>
                <DateTimeRenderer value={order.modifiedDate}/>
            </ClayTable.Cell>
            <ClayTable.Cell>
                <ClayButtonWithIcon className="bg-danger ml-1" onClick={() => deleteAction(order.id)}
                                    symbol="times"
                                    spritemap={Liferay.ThemeDisplay.getPathThemeImages() + "/clay/icons.svg"}/>
            </ClayTable.Cell>
        </ClayTable.Row>
    )
}

export default OrderTableRow;